/// <reference path="../CFlexContainer.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class Window extends CFlexContainer {
        /**
         *
         * @param data
         */
        protected initialize(data: any) {
            super.initialize(data);
            this.addClass("w");
            this.initController();
        }

        protected initController() {
            const wca = this.translate("#wca");
            if (wca) {
                this.addToData("wcancel", () => {
                    getAppService().processAction(toMap(wca));
                    // getWebPageService().removeCurrentApp();
                });
            }

            const waa = this.translate("#waa");
            if (waa) {
                this.addToData("waccept", () => {
                    getAppService().processAction(toMap(waa));
                });
            }

            if (!this.get("wcancel") || !(this.get("wcancel") instanceof Function)) {
                this.addToData("wcancel", () => {
                    getWebPageService().removeCurrentApp();
                });
            }
            this.createControlPanel();
        }

        protected createControlPanel() {
            let t = this.get("title");
            if (!t && this.hasTrans("#wt")) {
                t = this.translate("#wt");
            }
            const cp = new WindowHead(toMap({
                accept: this.get("waccept"),
                cancel: this.get("wcancel"),
                title: t,
            }));
            this.addToData("controlPanel", cp);
            this.insertOnTop(cp);
        }

        protected createByType(data: Map<any, any>, main: Tag) {
            Page.createNewByType(data, main);
        }
    }
}
